import type { RootStore } from '~/stores/root.store';
import { CompanyStore } from '~/stores/company.store';
import {
    IProjectSearchParams,
    IProjectSearchResponse
} from '~/types/server.types';

export class ProjectController {
    rootStore: RootStore;
    companyStore: CompanyStore;
    private readonly EXCLUDED_STAGES = ['_ARCHIVED_'];

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this.companyStore = rootStore.companyStore;
    }

    async fetchProject(projectId: string) {
        const { projectStore } = this.rootStore;
        const project = await this.rootStore.projectService.fetchProject(
            projectId
        );

        projectStore.load(project);
    }

    async fetchProjectList(
        query?: string,
        params?: IProjectSearchParams,
        excludeArchived?: boolean
    ): Promise<IProjectSearchResponse[]> {
        let response;
        if (!query) {
            response = await this.rootStore.projectService.getAllProjectList(
                params
            );
        } else {
            response = await this.rootStore.projectService.searchProjectList(
                query,
                params
            );
        }

        const filteredResponse = !excludeArchived
            ? response
            : response.filter(project => {
                  const stageId = project?.properties?.stage?._id;
                  const pipelineStages =
                      this.companyStore?.currCompany?.user_pipeline_stages;
                  const stage = pipelineStages?.find(s => s._id === stageId);

                  return stage && !this.EXCLUDED_STAGES.includes(stage.name);
              });

        return filteredResponse;
    }
}
